import { $authHost } from "./index";

export const getParse = async () => {
  const { data } = await $authHost.get("/api/parse");

  return data;
};

export const getStatus = async () => {
  const { data } = await $authHost.get("/api/parse/status/");

  return data;
};

export const upload = async (formData) => {
  const data = await $authHost.post("/api/parse", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
};

export const getRules = async () => {
  const { data } = await $authHost.get("/api/rules");

  return data;
};

export const getRule = async (id) => {
  const { data } = await $authHost.get(`/api/rules/${id}`);

  return data;
};

export const updateRule = async (id, body) => {
  const { data } = await $authHost.put(`/api/rules/${id}`, body);

  return data;
};

export const createRule = async (body) => {
  const { data } = await $authHost.post("/api/rules", body);

  return data;
};
